<div class="category-header">
    <h4  *ngIf="isSideBarOpen" >Admin Portal </h4>
    <!-- TODO fix lint-->
    <!-- eslint-disable @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
    <div class="collapse-icon" (click)="toggleSidebar()"><span class="pi pi-fw pi-align-justify "></span></div>
</div>
<p-panelMenu  *ngIf="isSideBarOpen"   [model]="items" [transitionOptions]="'0.2s ease-in'"></p-panelMenu>
